export const questionsRu = [
  {
    q: 'Как отдать карту?',
    a: 'После оформления карты вы получите доступ к личному кабинету. Там можно ввести номер финального получателя, после чего он сразу получит смс-уведомление с доступом к карте.'
  },
  {
    q: 'Как долго действует карта?',
    a: 'Срок действия – 12 месяцев с момента выпуска карты, указанный на обратной стороне карты (не с момента активации карты).<br/><br/>По истечении срока действия карты деньги на ней сгорают.'
  },
  { q: 'Можно ли ее пополнять в будущем?', a: 'Эту карту пополнять нельзя.' },
  {
    q: 'В каких магазинах можно использовать карту?',
    a: 'Картой можно оплачивать любые услуги и товары на территории MEGA.'
  },
  { q: 'Можно ли снять деньги с карты?', a: 'Снять наличные невозможно.' },
  { q: 'Можно ли оформить цифровую карту?', a: 'Да, цифровую карту можно выпустить на странице оформления.' },
  {
    q: 'Как долго готовится пластик?',
    a: 'Пластик выпускается моментально. Выпустить пластиковую карту можно в MEGA '
  },
  {
    q: 'Как подарить пластиковую карту?',
    a: 'Пластиковую карту можно приобрести в MEGA. Сначала она будет зарегистрирована на вас и появится в личном кабинете, в котором ее можно зарегистрировать на конечного получателя.'
  },
  { q: 'Можно ли картой расплачиваться в интернете?', a: 'Нет, карта работает только на территории ТРЦ MEGA.' },
  { q: 'Как узнать баланс карты?', a: 'Баланс можно проверить в личном кабинете на странице банка.' },
  { q: 'Можно ли добавить карту в мобильный кошелёк?', a: 'Да, в Apple Pay, Samsung Pay, Google Pay или Garmin Pay.' },
  {
    q: 'Что произойдёт с деньгами на карте, когда её срок действия закончится? ',
    a: 'Неиспользованная сумма на карте сгорает.'
  },
  {
    q: 'Вернутся ли деньги, если я сделаю возврат товара? ',
    a: 'Да, при условии, что возврат оформлен не позднее чем за 14 дней до окончания срока действия карты.'
  }
]
